import * as _ from 'lodash';

export function convertDateFields(object: Object, fieldNames: string[]) {
    _.each(fieldNames, (field) => {
        object[field] = new Date(object[field]);
    });
}
